const DefaultDialogPlayerEvent = {};
export default DefaultDialogPlayerEvent;

DefaultDialogPlayerEvent.START_DIALOG = "DefaultDialogPlayerEvent.START_DIALOG";
DefaultDialogPlayerEvent.DIALOG_COMMAND = "DefaultDialogPlayerEvent.DIALOG_COMMAND";
DefaultDialogPlayerEvent.DIALOG_OPTION = "DefaultDialogPlayerEvent.DIALOG_OPTION";
DefaultDialogPlayerEvent.END_DIALOG = "DefaultDialogPlayerEvent.END_DIALOG";
DefaultDialogPlayerEvent.ENTER_DIALOG_STATE = "DefaultDialogPlayerEvent.ENTER_DIALOG_STATE";
DefaultDialogPlayerEvent.EXIT_DIALOG_STATE = "DefaultDialogPlayerEvent.EXIT_DIALOG_STATE";
DefaultDialogPlayerEvent.ENTER_DIALOG_TRANSITION = "DefaultDialogPlayerEvent.ENTER_DIALOG_TRANSITION";
DefaultDialogPlayerEvent.EXIT_DIALOG_TRANSITION = "DefaultDialogPlayerEvent.EXIT_DIALOG_TRANSITION";
DefaultDialogPlayerEvent.DIALOG_TIME_OUT = "DefaultDialogPlayerEvent.DIALOG_TIME_OUT";
DefaultDialogPlayerEvent.DIALOG_TIME_TICK = "DefaultDialogPlayerEvent.DIALOG_TIME_TICK";
DefaultDialogPlayerEvent.AUTO_TAKE_TIME_TICK = "DefaultDialogPlayerEvent.AUTO_TAKE_TIME_TICK";
DefaultDialogPlayerEvent.COMMAND_SEQUENCE_TIME_TICK = "DefaultDialogPlayerEvent.COMMAND_SEQUENCE_TIME_TICK";
DefaultDialogPlayerEvent.CONTENT = "DefaultDialogPlayerEvent.CONTENT";
DefaultDialogPlayerEvent.SCORE = "DefaultDialogPlayerEvent.SCORE";
DefaultDialogPlayerEvent.AUTO_TAKE_OPTION_TAKEN = "AUTO_TAKE_OPTION_TAKEN";
DefaultDialogPlayerEvent.COMMAND_SEQUENCE_END  = "DefaultDialogPlayerEvent.COMMAND_SEQUENCE_END";